const locale = {
    placeholder: 'Chọn thời gian',
};
export default locale;
